import React from 'react';
import PropTypes from 'prop-types';
import GenericIcon from './fontIcons/genericIcon';
import './fontIcons/fontIconStyle.css';

const GiftcardIcon = ({ ...props }) => {
  const { color, size } = props;
  return <GenericIcon color={color} size={size} fontClass="icon-ic_giftcard" />;
};

GiftcardIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.string,
};

export default GiftcardIcon;
